var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"synap",staticStyle:{"height":"100%"},attrs:{"id":"synapEditor"}})
}
var staticRenderFns = []

export { render, staticRenderFns }